import { render, staticRenderFns } from "./DriverPerformance.vue?vue&type=template&id=798ad3d3"
import script from "./DriverPerformance.vue?vue&type=script&lang=ts"
export * from "./DriverPerformance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports